import { RequestCartItemsCamelPayload, RequestCartItemsPayload } from '@/mobx/types/order';
import { TCloudDetailInfo, TGetCloudSubscribeInfoResponse } from '@/types/cloud';
import { TBEBillingDetail, TBEDeliveryDetail, TBillingDetail, TDeliveryDetail } from '@/types/delivery';
import { camelToUnderline } from '@/utils';
import { isEmpty, omit } from 'lodash';
import { ApiResponse } from '../typings';

// 修改data的数据类型，U和T分别是修改前 / 修改后的type
export type FieldFormatter<TBefore, TAfter> = (data: TBefore) => TAfter;

export const formatAPiGetTradeData: FieldFormatter<RequestCartItemsPayload[], RequestCartItemsCamelPayload[]> = (
  data
) => {
  return data.map((item) => ({
    commodityId: item.id,
    number: item.number,
    bindServices: item.bind_services?.map((bindItem) => ({
      commodityId: bindItem.id,
      number: bindItem.number,
    })),
  }));
};

/** 快递地址的后端接口驼峰 转 内部下划线字段 */
const transformDelivery: FieldFormatter<TBEDeliveryDetail, TDeliveryDetail> = (data) => {
  if (isEmpty(data)) return data as unknown as TDeliveryDetail;
  // 确定当前需要转换成下划线的字段，避免后面新增了驼峰字段 默认给转成下划线了，造成后续的debug问题
  const needTransFileds = [
    'firstName',
    'lastName',
    'subAddress',
    'phoneCode',
    'zipCode',
    'countryCode',
    'isDefault',
  ] as unknown as (keyof TBEDeliveryDetail)[];
  const transformData = { ...omit(data, needTransFileds) };
  needTransFileds.forEach((key) => {
    const _key = camelToUnderline(key) as keyof TDeliveryDetail;
    const value = data[key];
    (transformData as Record<keyof TDeliveryDetail, unknown>)[_key] = value;
  });

  return transformData as TDeliveryDetail;
};

/** 账单地址的后端接口驼峰 转 内部下划线字段 */
const transformBilling: FieldFormatter<TBEBillingDetail, TBillingDetail> = (data) => {
  if (isEmpty(data)) return data as unknown as TBillingDetail;
  // 确定当前需要转换成下划线的字段，避免后面新增了驼峰字段 默认给转成下划线了，造成后续的debug问题
  const needTransFileds = [
    'firstName',
    'lastName',
    'subAddress',
    'phoneCode',
    'zipCode',
    'countryCode',
    'isDefault',
  ] as unknown as (keyof TBEBillingDetail)[];
  const transformData = { ...omit(data, needTransFileds) };
  needTransFileds.forEach((key) => {
    const _key = camelToUnderline(key) as keyof TBillingDetail;
    const value = data[key];
    (transformData as Record<keyof TBillingDetail, unknown>)[_key] = value;
  });

  return transformData as TBillingDetail;
};

/** 云存接口/cloud/getCloudStorageSubscribeInfo，响应参数里面的地址 */
export const formatGetCloudSubscribeInfo: FieldFormatter<
  ApiResponse<TGetCloudSubscribeInfoResponse>,
  ApiResponse<TCloudDetailInfo>
> = (res) => {
  if (res.code === 0 && !!res.data) {
    if (res.data.cloudSubscribeInfo) {
      // 转换订单地址
      res.data.cloudSubscribeInfo.subscribeOrderAddress = transformDelivery(
        res.data.cloudSubscribeInfo.subscribeOrderAddress
      ) as unknown as TBEDeliveryDetail;

      // 转换账单地址
      res.data.cloudSubscribeInfo.subscribeBillingAddress = transformBilling(
        res.data.cloudSubscribeInfo.subscribeBillingAddress
      ) as unknown as TBEBillingDetail;
    }

    return res as unknown as ApiResponse<TCloudDetailInfo>;
  }

  return res as ApiResponse<TCloudDetailInfo>;
};
